import React, { useRef } from "react";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebookF,
  FaTwitter,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

const Footer = () => {
  const navigate = useNavigate();
  const form = useRef();

  // helper to scroll top + navigate
  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  // handle subscription form
  const handleSubscribe = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_108fu8k", "template_hykwi6i", form.current, {
        publicKey: "dSxES0gVKjdpWLqFr",
      })
      .then(
        () => {
          alert("Subscribed Successfully 🎉");
          form.current.reset(); //  clear input after success
        },
        (error) => {
          alert("Subscription Failed ❌ " + error.text);
        }
      );
  };

  return (
    <footer className="footer-section text-white py-5">
      <div className="container-fluid px-md-5">
        <div className="row gy-4 text-center text-md-start">
          {/* Address */}
          <div className="col-md-5 px-md-5">
            <h5 className="fw-bold px-md-5">Tower International Group, LLC</h5>
            <p className="mb-1 px-md-5">
              Office 204,
              <br />
              2nd Floor, Al Assalah Towers,
              <br />
              Muscat, Sultanate of Oman
            </p>
            <p className="mb-1 px-md-5">
              <strong>Contact Number :</strong>{" "}
              <a
                href="tel:+96822842089"
                className="text-decoration-none text-white"
              >
                +968 2284 2089
              </a>
            </p>
            <p className="px-md-5">
              <strong>Email :</strong>{" "}
              <a
                href="mailto:info@tig-oman.com"
                className="text-decoration-none text-white"
              >
                info@tig-oman.com
              </a>
            </p>

            <div className="d-flex justify-content-center justify-content-md-start gap-2 mt-3 px-md-5">
              <a target="_blank" className="social-icon" href="https://www.linkedin.com/company/towers-international-group/">
                <FaLinkedin />
              </a>
              <a className="social-icon">
                <FaInstagram />
              </a>
              <a className="social-icon">
                <FaFacebookF />
              </a>
              <a className="social-icon">
                <FaTwitter />
              </a>
            </div>
          </div>

          {/* Our Businesses */}
          <div className="col-md-4 px-3">
            <h6 className="fw-bold footer-title">Our Businesses</h6>
            <ul className="list-unstyled footer-links">
              <li>
                <button
                  onClick={() => handleNavigate("/northstar")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  NorthStar Financial Consultancy
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/vodafone")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  VODAFONE Distribution
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/elevate")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  Elevate Management Services LLC
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/newelite")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  New Elite International LLC
                </button>
              </li>
              <li>
                <a
                  href="https://tig-oman.com/mbc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-links-link"
                >
                  Modern Buildings Constructions LLC
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-md-3">
            <h6 className="fw-bold footer-title">Quick Link</h6>
            <ul className="list-unstyled footer-links">
              <li>
                <a
                  href="https://towers-training.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-links-link"
                >
                  Towers Training
                </a>
                </li>
              <li>
                <button
                  onClick={() => handleNavigate("/hrsolution")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  HR Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/itsolution")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  IT Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/cxda")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                   CXDA
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavigate("/contact")}
                  className="footer-links-link btn btn-link p-0 text-start"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Subscribe */}
          {/* <div className="col-md-3">
            <h6 className="fw-bold footer-title">Subscribe Us</h6>
            <p>
              It is a long established fact that a reader will be distracted by
              the readable
            </p>\
            <form ref={form} onSubmit={handleSubscribe}>
              <input
                type="email"
                className="form-control mb-3"
                placeholder="Email"
                name="email" 
                required
              />
              <div className="d-flex justify-content-center justify-content-md-end">
                <button type="submit" className="btn btn-danger w-50">
                  Submit
                </button>
              </div>
            </form>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
